import React, { useState } from 'react';
import AuthMobile from '@/common/components/BasicLogin/components/AuthMobile';
import ResetPassword from './ResetPassword';
import ResetResult from '@/common/components/BasicLogin/components/ResetResult';
import styles from '@/common/components/BasicLogin/components/ForgetPassword/index.less';

type ForgetPasswordProps = {
  /** 返回登录回调 */
  backLogin?: () => void;
  /** 白色背景 */
  white?: boolean;
};

/** 忘记密码 */
const ForgetPassword: React.FC<ForgetPasswordProps> = (props) => {
  const { backLogin, white } = props;
  const [currentStep, setCurrentStep] = useState(0);
  const [token, setToken] = useState('');

  return (
    <div className={styles['forget-password']}>
      <h4 className={styles['forget-title']}>重置密码</h4>
      <div className={styles['step-container']}>
        <div
          className={`${styles['step-item']} ${currentStep >= 0 ? styles['step-active'] : ''} ${
            currentStep >= 1 ? styles['step-finsh'] : ''
          }`}
        >
          <span className={styles['step-dot']} />
          <span className={styles['step-name']}>账号验证</span>
        </div>
        <div
          className={`${styles['step-item']} ${currentStep >= 1 ? styles['step-active'] : ''} ${
            currentStep >= 2 ? styles['step-finsh'] : ''
          }`}
        >
          <span className={styles['step-dot']} />
          <span className={styles['step-name']}>重置密码</span>
        </div>
        <div className={`${styles['step-item']} ${currentStep === 2 ? styles['step-active'] : ''}`}>
          <span className={styles['step-dot']} />
          <span className={styles['step-name']}>重置成功</span>
        </div>
      </div>
      {currentStep === 0 ? (
        <AuthMobile
          white={white}
          onNext={(v) => {
            setCurrentStep(1);
            setToken(v);
          }}
          backLogin={backLogin}
        />
      ) : null}
      {currentStep === 1 ? (
        <ResetPassword
          white={white}
          token={token}
          onNext={() => setCurrentStep(2)}
          backLogin={backLogin}
        />
      ) : null}
      {currentStep === 2 ? <ResetResult backLogin={backLogin} /> : null}
    </div>
  );
};

export default ForgetPassword;
